module.exports = __webpack_public_path__ + "static/img/tuzheng_01.4471ac3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tuzheng_01.png
// module id = CLYX
// module chunks = 1